import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { formatInvoiceNumber, Invoice } from "../../models/invoice";

interface InvoiceDeleteModalProps {
  show: boolean;
  invoice?: Invoice;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const InvoiceDeleteModal: React.FC<InvoiceDeleteModalProps> = ({
  show,
  invoice,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = invoice
    ? `Está seguro de que quiere eliminar la factura ${formatInvoiceNumber(
        invoice
      )}`
    : "";

  const onDeleteClick = async () => {
    if (invoice !== undefined) {
      setSubmitting(true);
      const invoiceStatus = await deleteItem(
        `/invoices/${invoice.id}/`,
        invoice
      );

      if (invoiceStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (invoiceStatus.detail !== undefined) {
          message = invoiceStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default InvoiceDeleteModal;
